// eslint-disable-next-line import/prefer-default-export
export const actionCreator = (type, payload) => {
  if (payload !== undefined) return { type, payload };
  return { type };
};
